/* eslint-disable prefer-destructuring */
import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as CommonNavStepStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/components/NavigationStep";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { focusStyle } from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";

export const Step = styled.span.attrs(() => ({
    className: "t-base-headline",
}))<{ isActive?: boolean; noPadding?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.space[1]}px;

    @supports not (gap) {
        > span:nth-last-child(1) {
            margin-left: ${theme.space[1]}px;
        }
    }

    margin-bottom: 0;
    color: ${({ isActive }) => (isActive ? theme.colors.grey3 : theme.colors.primaryWhite)};

    @media ${getBreakpoint("up", "lg")} {
        color: ${({ isActive }) => (isActive ? theme.colors.primaryWhite : theme.colors.grey3)};
    }

    html[dir="rtl"] & {
        @supports not (gap) {
            > span:nth-last-child(1) {
                margin-left: 0;
                margin-right: ${theme.space[1]}px;
            }
        }
    }
`;

export const StepText = CommonNavStepStyles.StepText;

export const StepWithoutLink = styled.a`
    cursor: default;
`;

export const Icon = styled.span<{ isActive?: boolean }>`
    display: none;
    color: ${({ isActive }) => (isActive ? theme.colors.primaryWhite : theme.colors.grey3)};

    @media ${getBreakpoint("up", "lg")} {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const Wrapper = styled.li<{ isActive?: boolean }>`
    display: flex;
    position: relative;
    justify-content: center;
    margin-bottom: 0;
    padding: ${theme.space[1]}px 0;
    background-color: ${theme.colors.primaryBlack};

    @media ${getBreakpoint("up", "lg")} {
        padding: 0;
        &:not(:first-child) {
            padding-inline-start: 36px; /* 12px (dash) + 24px spacing */

            @supports not (padding-inline: 0) {
                padding-left: 36px;
            }

            &::before {
                display: block;
                position: absolute;
                top: 50%;
                left: 0;
                width: 12px;
                height: 1px;
                content: "";
                background-color: ${({ isActive }) => (isActive ? theme.colors.primaryWhite : theme.colors.grey3)};
                transform: translateY(-50%);
            }
        }
    }

    a {
        text-decoration: none;
        ${focusStyle};
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "lg")} {
            @supports not (padding-inline: 0) {
                padding-left: 0;
                padding-right: 36px;
            }
            &::before {
                left: auto;
                right: 0;
            }
        }
    }
`;
